import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import SplitterPaneViewModel from '@/ViewModels/Controls/SplitterPaneViewModel';
import { ISplitterViewModelParameters } from '#/DefaultViewExtensionInterfaces';
import SplitterPaneDividerViewModel from '@/ViewModels/Controls/SplitterPaneDividerViewModel';

export default class SplitterViewModel extends ControlViewModel {

    /**
     * Gibt an, ob es sich um einen horizontalen Splitter handelt.
     * Horizontal bedeutet, dass die Elemente nebeneinander statt untereinander sind
     */
    public isHorizontal: KnockoutObservable<boolean>;

    /**
     * Die Bereiche des Splitters
     */
    public panes: SplitterPaneViewModel[];

    public dividers: SplitterPaneDividerViewModel[];

    /**
     * Das ViewModel für den Splitter
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: ISplitterViewModelParameters) {
        super(params);

        this.isHorizontal = this.observableOrDefault(params.isHorizontal, false);
        this.panes = this.paramOrDefault(params.panes, []);
        this.dividers = this.paramOrDefault(params.dividers, []);

        for (const divider of this.dividers) {
            divider.registerResizeStartHandler(() => this.toggleResizeOverlays(true));
            divider.registerResizeEndHandler(() => this.toggleResizeOverlays(false));
        }

        this.defineSubscription(this.isHorizontal, isHorizontal => {
            for (const pane of this.panes) {
                pane.isHorizontal(isHorizontal);
            }
        })(this.isHorizontal());
    }

    private toggleResizeOverlays(show: boolean) {
        for (const pane of this.panes.filter(p => p.useResizeOverlay)) {
            pane.showResizeOverlay(show);
        }
    }
}

ComponentManager.setViewModel('SplitterViewModel', SplitterViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');